<template>
  <Layout>
    <div :class="$style.sectionContact">
      <div class="container">
        <div class="dingbeauty-banner-content ">
          <p class="sub-title">Contact</p>
          <h1 class="title">專人聯繫</h1>
          <div class="description">
            <p>經營美容服務的所有管理工作是否有些混亂？</p>
            <p>請留下您的聯繫方式，我們將儘速安排專人為您服務！</p>
            <p>簡化寵物服務的管理，提高管理工作效率，更能安心為您的客戶提供更佳的服務！</p>
            <p>如有任何疑問，歡迎隨時與我們聯繫，我們在這裡做您的支援。</p>
          </div>
        </div>
      </div>
    </div>
    <!-- <SectionForm></SectionForm> -->
    <div class="container section">
      <div class="dingbeauty-form__wrapper">
        <ValidationObserver v-slot="{ invalid, handleSubmit }">
          <el-form ref="form" :model="submitData" class="dingbeauty-form" @submit.prevent.native="handleSubmit(onSubmit)">
            <ValidationProvider v-slot="{ errors }" rules="require" name="姓名">
              <el-form-item label="你的大名*" prop="name" :error="errors[0]">
                <el-input v-model="submitData.name"></el-input>
              </el-form-item>
            </ValidationProvider>

            <div class="grid--1x2">
              <ValidationProvider v-slot="{ errors }" rules="require|email" name="電子郵件">
                <el-form-item label="電子郵件地址*" prop="email" :error="errors[0]">
                  <el-input v-model="submitData.email"></el-input>
                </el-form-item>
              </ValidationProvider>

              <ValidationProvider v-slot="{ errors }" rules="require|phone" name="電話">
                <el-form-item label="聯絡電話*" prop="phone" :error="errors[0]">
                  <el-input v-model="submitData.phone"></el-input>
                </el-form-item>
              </ValidationProvider>
            </div>

            <ValidationProvider v-slot="{ errors }" rules="require" name="留言訊息">
              <el-form-item label="留言訊息*" prop="message" :error="errors[0]">
                <el-input v-model="submitData.message"></el-input>
              </el-form-item>
            </ValidationProvider>
            <!-- <template v-if="isSend">
            <BaseButton :loading="loadingSendContact" type="button" class="isStylePrimary submit">
              已成功送出訊息
            </BaseButton>
          </template>
          <template v-else>
            <BaseButton :loading="loadingSendContact" type="submit" class="isStylePrimary submit">
              送出訊息
            </BaseButton>
          </template> -->
            <button v-if="isSend" class="dingbeauty-btn" :class="{ 'is-loading': loadingSendContact }" @click.prevent>已成功送出訊息</button>
            <button v-else class="dingbeauty-btn" :class="{ 'is-loading': loadingSendContact }">送出訊息</button>
          </el-form>
        </ValidationObserver>
      </div>
    </div>

    <SectionSocialMedia></SectionSocialMedia>
    <GoogleReCaptchaV3 id="contact_us_captcha" ref="captcha" v-model="submitData.g_recaptcha_response" :site-key="googleReCaptcha.siteKey" :inline="false" action="contact_us"></GoogleReCaptchaV3>
  </Layout>
</template>

<script>
import Layout from '@layout/main'
// import SectionForm from './components/SectionForm'
import SectionSocialMedia from './components/SectionSocialMedia'
import GoogleReCaptchaV3 from '@components/GoogleReCaptchaV3'
import { messageSuccess } from '@utils/message'

export default {
  page() {
    return {
      title: '方案價格',
    }
  },
  components: {
    Layout,
    // SectionForm,
    SectionSocialMedia,
    GoogleReCaptchaV3,
  },

  data() {
    return {
      submitData: {
        name: '',
        email: '',
        phone: '',
        message: '',
        g_recaptcha_response: '',
      },
      googleReCaptcha: {
        siteKey: '6Lf2LlcbAAAAANb1gKClQNEbRRAjU5RfIJ3sIm3v',
      },
      // loadingGetCode: false,
      loadingSendContact: false,
      isSend: false,
    }
  },

  methods: {
    onSubmit() {
      this.tryToSendContact()
    },
    async tryToSendContact() {
      this.loadingSendContact = true
      await this.$store
        .dispatch('send/sendContact', {
          ...this.submitData,
        })
        .then((response) => {
          this.$notify({
            title: '已送出訊息',
            message: '您的訊息已成功送出，我們將盡快回覆您',
            iconClass: 'successIcon',
            customClass: 'isStyleBase',
            offset: 100,
          })
          this.isSend = true
        })
        .finally(() => {
          this.loadingSendContact = false
        })
    },
  },
}
</script>

<style lang="scss" module>
.sectionContact {
  position: relative;
  background-image: url('@assets/dingbeauty-images/contact/banner052.jpg');
  height: 100vh;
  background-size: cover;
  background-position: 78% center;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    display: inline-block;
    background-color: rgba($color: #000000, $alpha: 0.2);
    width: 100%;
    height: 100%;
  }

  :global {
    .form-wrapper {
      max-width: 1260px;
    }
  }
}

@media (min-width: 992px) {
  .sectionContact {
    height: 700px;
    background-position: center;
  }
}
</style>

<style lang="scss">
// Form Style
$color-primary: #e3c192;
$color-form: #545662;
$color-value: #0c1c30;

.dingbeauty-form__wrapper {
  max-width: 1260px;
  margin: auto;
  border: 1px solid $color-primary;
  padding: 30px 20px;
}

.dingbeauty-form {
  .el-form-item__label {
    margin-bottom: 0;
    padding-bottom: 0;
    line-height: 20px;
  }

  .el-input__inner {
    color: $color-value;
    border: none;
    border-bottom: 1px solid $color-form;
    border-radius: 0;
    padding: 0;
  }

  .dingbeauty-btn {
    width: 100%;
    max-width: 400px;
    padding: 16px;
    margin-top: 30px;
  }
}

@media (min-width: 992px) {
  .dingbeauty-form__wrapper {
    max-width: 1260px;
    margin: auto;
    border: 1px solid $color-primary;
    padding: 60px 40px;
  }

  .dingbeauty-form {
    .grid--1x2 {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 20px;
    }

    .dingbeauty-btn {
      margin-top: 60px;
    }
  }
}
</style>
